"use client";
import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { fontAwesome } from "@/styles/fonts";

export default function TestimonialCarousel({ children }: { children: React.ReactNode }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(false);
    const items = React.Children.toArray(children);

    useEffect(() => {
        const update = () => setIsMobile(window.innerWidth < 768);
        update();
        window.addEventListener("resize", update);
        return () => window.removeEventListener("resize", update);
    }, []);

    const handlePrev = () => {
        setCurrentIndex((prev) => (prev === 0 ? items.length - 1 : prev - 1));
    };

    const handleNext = () => {
        setCurrentIndex((prev) => (prev === items.length - 1 ? 0 : prev + 1));
    };

    return (
        <div className="relative">
            <div className={clsx(
                "pt-[25px]",
                "md:pt-[70px]",
                "pb-[50px]",
                "gap-[30px]",
                "px-[40px]",
                isMobile ? "flex justify-center" : "grid md:grid-cols-2 justify-center",
            )}>
                {isMobile
                    ? items[currentIndex]
                    : items
                }
            </div>
            <button
                className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-gray-200 p-2 rounded-full"
                onClick={handlePrev}
            >
                <span className={`${fontAwesome.className}`} aria-hidden="true">
                    
                </span>
            </button>
            <button
                className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-gray-200 p-2 rounded-full"
                onClick={handleNext}
            >
                <span className={`${fontAwesome.className}`} aria-hidden="true">
                    
                </span>
            </button>
        </div>
    );
}
